import { render, staticRenderFns } from "./CoredataForm.vue?vue&type=template&id=d88da6ce&scoped=true&"
import script from "./CoredataForm.vue?vue&type=script&lang=js&"
export * from "./CoredataForm.vue?vue&type=script&lang=js&"
import style0 from "./CoredataForm.vue?vue&type=style&index=0&id=d88da6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88da6ce",
  null
  
)

export default component.exports